import {
  set, observable, action,
} from 'mobx';
import { IFromBopisInfoResponse } from '../../../api/IDataMappings';

export interface PickupUserInfo {
  phone: string;
  firstName: string;
  email: string;
  lastName: string;
}

class Bopis {
  @observable countryId: number;

  @observable proxyPickupMode: boolean;

  @observable purchaserPickupInfo: PickupUserInfo;

  @observable proxyPickupInfo: PickupUserInfo;

  @observable doorId: string;

  @observable bopisGWRemoved: boolean;

  static fromJSON(data: IFromBopisInfoResponse): Bopis {
    const bopisInfo = new Bopis();
    set(bopisInfo, data);

    return bopisInfo;
  }

  @action
  setStore(doorId: string): void {
    this.doorId = doorId;
  }
}

export default Bopis;
